/**
 * Translate LimeSpot "You may like" quick-action labels.
 *
 * LimeSpot renders Add to cart from its own box options (default English
 * "ADD TO CART") and is not compatible with Shopify Translate & Adapt.
 * This patches renderBox before boxes mount, and rewrites any leftover
 * English button text if the UI updates later.
 *
 * Expects window.pokecccLimespotI18n.addToCart (set from Liquid locales).
 */
(function () {
  'use strict';

  var ENGLISH_ADD_TO_CART = /^\s*add(\s+selected)?\s+to\s+cart\s*$/i;

  function label() {
    var cfg = window.pokecccLimespotI18n;
    if (cfg && cfg.addToCart) return cfg.addToCart;
    if (window.variantStrings && window.variantStrings.addToCart) {
      return window.variantStrings.addToCart;
    }
    return null;
  }

  function applyOptions(options) {
    var text = label();
    if (!text || !options || !options.AppearanceOptions) return;
    options.AppearanceOptions.QuickActionsAddToCartTitle = text;
  }

  function patchRenderBox() {
    if (!window.LimeSpot || !LimeSpot.recommendation) return false;
    var renderBox = LimeSpot.recommendation.renderBox;
    if (typeof renderBox !== 'function') return false;
    if (renderBox.__pokecccI18n) return true;

    LimeSpot.recommendation.renderBox = function (args) {
      if (args && args.options) applyOptions(args.options);
      return renderBox.apply(LimeSpot.recommendation, arguments);
    };
    LimeSpot.recommendation.renderBox.__pokecccI18n = true;
    return true;
  }

  function rewriteNodeText(root) {
    var text = label();
    if (!text || !root || !root.querySelectorAll) return;

    root.querySelectorAll('button, a, [role="button"], .ls-quick-action, .ls-add-to-cart, [class*="add-to-cart"], [class*="AddToCart"]').forEach(function (el) {
      var raw = (el.textContent || '').trim();
      if (!ENGLISH_ADD_TO_CART.test(raw)) return;
      if (el.childElementCount === 0) {
        el.textContent = text;
        return;
      }
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && ENGLISH_ADD_TO_CART.test(node.textContent)) {
          node.textContent = text;
        }
      });
    });
  }

  /** LimeSpot sets inline margin-top on arrows; clear it so CSS can center them. */
  function normalizeArrows(root) {
    if (!root || !root.querySelectorAll) return;
    root
      .querySelectorAll(
        '.limespot-recommendation-box-carousel-indicator, .ls-left-arrow, .ls-right-arrow'
      )
      .forEach(function (el) {
        if (el.style && el.style.marginTop) el.style.marginTop = '';
      });
  }

  function polishBox(root) {
    rewriteNodeText(root);
    normalizeArrows(root);
  }

  function observeBoxes() {
    if (!document.documentElement) return;

    polishBox(document);

    if (window.__pokecccLimespotI18nObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (
              node.matches &&
              (node.matches('limespot-box, .limespot-box, .ls-recommendation-box') ||
                node.querySelector(
                  'limespot-box, .limespot-box, .ls-recommendation-box, .limespot-recommendation-box-carousel-indicator, .ls-add-to-cart'
                ))
            ) {
              polishBox(node);
            }
          });
        } else if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var styled = mutation.target;
          if (
            styled &&
            styled.classList &&
            (styled.classList.contains('limespot-recommendation-box-carousel-indicator') ||
              styled.classList.contains('ls-left-arrow') ||
              styled.classList.contains('ls-right-arrow'))
          ) {
            normalizeArrows(styled.parentNode || styled);
          }
        } else if (mutation.type === 'characterData' || mutation.type === 'childList') {
          var target = mutation.target;
          if (target && target.closest) {
            var box = target.closest('limespot-box, .limespot-box, .ls-recommendation-box');
            if (box) polishBox(box);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style'],
    });
    window.__pokecccLimespotI18nObserver = observer;
  }

  // Capture phase so we wrap renderBox before LimeSpot's own lsPageInfoReady handler.
  document.addEventListener(
    'lsPageInfoReady',
    function () {
      patchRenderBox();
    },
    true
  );

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (patchRenderBox() || tries > 120) clearInterval(timer);
  }, 50);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBoxes);
  } else {
    observeBoxes();
  }
})();
